import { DropdownSelectorType } from '../types/interfaces';

export const TaskTypeOptions: DropdownSelectorType[] = [
  { label: 'Тип наряда 1', id: 1703873956536 },
  { label: 'Тип наряда 2', id: 1703873956534 },
  { label: 'Тип наряда 3', id: 1703873956533 }
];
